export { FunctionalityTile } from './FunctionalityTile';
